import React, { FC, useEffect, useState } from 'react';
import { ContentCard } from '../Cards';
import { getPersonNameFirst } from '../../utils/NameHelper';
import { UserDetail } from '../../types/api/users/UserDetail';
import { Nullable } from '../../types/custom/Nullable';
import { permissionsService } from '../../utils/PermissionService';
import { EmployeeDetail } from '../../types/api/employees/EmployeeDetail';
import { EnrollmentPackageList } from '../../components/Enrollment/EnrollmentPackageList';
import { useApiCall } from '../../hooks/api/apiHooks';
import { fetchPackageSummariesForPerson } from '../../apiCalls/enrollmentPackages/enrollmentPackageApiCalls';

export const HomePage: FC = () => {

	const [ user, setUser ] = useState<Nullable<UserDetail>>(null);
	const [ person, setPerson ] = useState<Nullable<EmployeeDetail>>(null);
	const { apiCall: getPackages, data: enrollmentList, isLoading } = useApiCall(fetchPackageSummariesForPerson);

	useEffect(() => {
		const getUserDetails = async() => {
			const result = await permissionsService.getCurrentUser();
			setUser(result);
			const person = await permissionsService.getCurrentPerson();
			if(person) {
				getPackages(person.personId);
				setPerson(person);
			}
		};
		getUserDetails();
	}, []);

	const employeeName = getPersonNameFirst(person);

	return (
		<React.Fragment>
			{user &&
				<ContentCard loading={isLoading}>
					{enrollmentList && 
						<div>
							<p>Hello{employeeName ? ', ' + employeeName : null}!</p>
							<p>Welcome to your WolfTracs employee benefits enrollment tool.</p>
							<p>For an active enrollment package, please click Enroll to complete or make changes to your benefit selections.</p>
							<p>If your enrollment package shows a status of Expired, it means your enrollment deadline has passed.  If you still hope to enroll, you will need to reach out to your Human Resources team to request additional time.</p>
							<p>For finished packages that have been Approved by your HR team, you can click Summary and review your benefit selections for that specific enrollment package.</p>
						</div>
					}
				</ContentCard>
			}
			{user && enrollmentList &&
				<EnrollmentPackageList currentUser={user} enrollmentList={enrollmentList}/>
			}
		</React.Fragment>
	);
};
